/* eslint-disable */
import React from "react";
import ReactECharts from "echarts-for-react";
import "./styles.scss";

const AppDownloadsPie = ({ data, colors }) => {
  const getEChartsOption = () => ({
    color: colors,
    series: [
      {
        type: "pie",
        radius: ["55%", "80%"],
        center: ["50%", "50%"], // Center the pie properly within its container
        data: data?.map(({ value, label }) => ({
          value: label,
          name: value,
        })),
        label: {
          show: false, // Remove default labels
        },
        labelLine: {
          show: false, // Remove lines from pie to labels
        },
      },
    ],
    legend: {
      show: false, // Disable default legend, we'll create custom
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
      position: function (point, params, dom, rect, size) {
        // Position tooltip to the right of the mouse cursor
        return [point[0] + 15, point[1]];
      },
    },
  });

  return (
    <div className="app-downloads-pie-container">
      <div className="app-downloads-pie-chart-section">
        {/* Pie Chart */}
        <div className="pie-chart-wrapper">
          <ReactECharts
            style={{ height: "200px", width: "200px" }}
            option={getEChartsOption()}
          />
        </div>

        {/* Custom Legend (without info icons) */}
        <div className="custom-legend">
          {data?.map((item, index) => (
            <div key={index} className="legend-item">
              <div className="legend-content">
                <div 
                  className="legend-line" 
                  style={{ backgroundColor: colors[index] }}
                />
                <span className="legend-number">{item.label}</span>
                <span className="legend-text">{item.value}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppDownloadsPie;
